import { AuthState } from '@slices/auth';
import { authSetAuthorizedReducer } from '@slices/auth/auth-set-authorized';
import { authSetUnauthorizedReducer } from '@slices/auth/auth-set-unauthorized';

import { appCreateSlice } from '@store/rtk';

export const authDefaultState: AuthState = {
  isAuthorized: false,
  isTestingUser: true,
};

const authSlice = appCreateSlice({
  name: 'auth',
  initialState: authDefaultState,
  reducers: {
    authSetAuthorized: authSetAuthorizedReducer,
    authSetUnauthorized: authSetUnauthorizedReducer,
  },
});

export const {
  actions: {
    authSetAuthorized, //
    authSetUnauthorized,
  },
  reducer: authReducer,
} = authSlice;
